export const elenaTestimonials = [
  {
    id: 1,
    name: '張偉',
    role: 'AI Software Engineer',
    company: '頭部跨國科技企業',
    companyColor: '#00A4EF',
    avatar: '/assets/readdy/nexusstudent01-80x80-squarish-1335f8b0.jpg',
    content: 'Elena 博士的面試衝刺課徹底改變了我的面試思維。她熟悉頂尖外商公司內部的招募標準，讓我在最終面試中表現超出預期。從投履歷到收到 Offer 只用了 6 週！',
    rating: 5,
    result: '成功拿到頂尖科技公司 AI 工程師 Offer',
    salary: '薪資提升 85%',
  },
  {
    id: 2,
    name: '陳曉明',
    role: 'Principal SDE',
    company: '全球頂尖電商平台',
    companyColor: '#FF9900',
    avatar: '/assets/readdy/nexusstudent02-80x80-squarish-340d26eb.jpg',
    content: '作為一個從台灣轉戰北美的工程師，語言和文化障礙是我最大的挑戰。Elena 的英文面試專項訓練讓我在 Leadership Principle 面試中游刃有餘，最終拿到 Principal SDE。',
    rating: 5,
    result: '從台灣成功轉戰外商北美總部',
    salary: 'TC 達到 $380K',
  },
  {
    id: 3,
    name: 'Sarah Chen',
    role: 'Research Scientist',
    company: '頭部 AI 研究機構',
    companyColor: '#0866FF',
    avatar: '/assets/readdy/nexusstudent03-80x80-squarish-0f832118.jpg',
    content: 'Elena 對 LLM 研究領域的深度認知無人能及。她協助我精準定位了頂尖 AI 研究團隊的方向，履歷精修後投遞通過率從 2% 提升到 35%。她是我遇過最 insightful 的導師。',
    rating: 5,
    result: '成功進入全球頂尖 AI Research 團隊',
    salary: '實現科研職涯突破',
  },
  {
    id: 4,
    name: '李建國',
    role: 'Senior PM, AI Products',
    company: '全球頂尖網路公司',
    companyColor: '#4285F4',
    avatar: '/assets/readdy/nexusstudent04-80x80-squarish-aa47509c.jpg',
    content: '從傳統產業跨界轉型 AI 產品經理，Elena 幫我重新梳理了整個職涯敘事。她對頂尖外商產品文化的理解非常深刻，讓我在 Case Study 中完美展現了產品思維。',
    rating: 5,
    result: '跨界轉型頂尖外商 AI 產品經理',
    salary: '薪資提升 120%',
  },
  {
    id: 5,
    name: '王芳',
    role: 'Senior Data Scientist',
    company: '頂尖 AI 晶片企業',
    companyColor: '#76B900',
    avatar: '/assets/readdy/nexusstudent05-80x80-squarish-b71c213e.jpg',
    content: '進入夢想中的頂尖 AI 硬體公司，真的是夢想成真。Elena 帶我深度了解了企業的技術文化和面試偏好，還幫我優化了 GPU 架構相關的技術表達。這是我做過最值得的投資。',
    rating: 5,
    result: '成功入職頂尖 AI 晶片公司資料科學團隊',
    salary: 'TC 超過 $320K',
  },
  {
    id: 6,
    name: '趙磊',
    role: 'AI Strategy Consultant',
    company: '全球頂尖顧問機構',
    companyColor: '#003580',
    avatar: '/assets/readdy/nexusstudent06-80x80-squarish-f1188d35.jpg',
    content: 'Elena 幫我將技術背景與商業思維完美融合，打造了一個獨特的 AI 策略顧問定位。頂尖管理顧問公司面試的 Case Study 她陪我演練了 8 遍，最終完美發揮。強烈推薦！',
    rating: 5,
    result: '成功進入全球頂尖顧問公司 AI 策略部門',
    salary: '進入頂尖管理顧問產業',
  },
];

export const homeTestimonials = [
  {
    id: 1,
    name: '張偉',
    role: 'AI Engineer @ 跨國科技企業',
    avatar: '/assets/readdy/homstudent01-60x60-squarish-812d08fa.jpg',
    content: 'Elena 博士的 1V1 指導讓我在 6 週內拿到了頂尖外商 AI 職缺 Offer，薪資提升了 85%。這是我職涯中最值得的投資。',
    company: '跨國科技企業',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    role: 'Research Scientist @ 頭部 AI 公司',
    avatar: '/assets/readdy/homestudent03-60x60-squarish-312d8d36.jpg',
    content: '從投遞通過率 2% 到 35%，NexusGo 的導師幫我徹底重構了求職策略。進入頂尖 AI 研究團隊是我奮鬥三年的目標，終於實現了！',
    company: '頭部 AI 公司',
  },
  {
    id: 3,
    name: '陳曉明',
    role: 'Principal SDE @ 全球電商巨擘',
    avatar: '/assets/readdy/homestudent02-60x60-squarish-dc29c754.jpg',
    content: 'NexusGo 幫我跨越了從台灣到北美職場的文化鴻溝。導師對頂尖外商 Leadership Principles 的精準解讀，讓我在面試中游刃有餘。TC $380K，超出預期！',
    company: '全球電商巨擘',
  },
];

export const genericTestimonials = [
  {
    id: 1,
    name: '張偉',
    role: 'AI Software Engineer',
    company: '頭部跨國科技企業',
    companyColor: '#00A4EF',
    avatar: '/assets/readdy/nexusstudent01-80x80-squarish-1335f8b0.jpg',
    content: '導師的面試衝刺輔導徹底改變了我的面試思維。她深知頂尖外商內部的招募標準，讓我在終輪面試中表現超出預期。從投履歷到收到 Offer 只用了 6 週！',
    rating: 5,
    result: '成功拿到頂尖科技公司 AI 工程師 Offer',
    salary: '薪資提升 85%',
  },
  {
    id: 2,
    name: '陳曉明',
    role: 'Principal SDE',
    company: '全球頂尖電商平台',
    companyColor: '#FF9900',
    avatar: '/assets/readdy/nexusstudent02-80x80-squarish-340d26eb.jpg',
    content: '從台灣轉戰北美，語言和文化障礙是我最大的挑戰。導師的英文面試專項訓練讓我在 Leadership Principle 環節游刃有餘，最終拿到 Principal SDE。',
    rating: 5,
    result: '從台灣成功轉戰外商北美總部',
    salary: 'TC 達到 $380K',
  },
  {
    id: 3,
    name: 'Sarah Chen',
    role: 'Research Scientist',
    company: '頭部 AI 研究機構',
    companyColor: '#0866FF',
    avatar: '/assets/readdy/nexusstudent03-80x80-squarish-0f832118.jpg',
    content: '導師對該領域的深度認知無人能及，幫我精準定位了頂尖 AI 研究團隊的方向，履歷精修後投遞通過率從 2% 提升到 35%。這是我遇過最 insightful 的導師。',
    rating: 5,
    result: '成功進入全球頂尖 AI Research 團隊',
    salary: '實現科研職涯突破',
  },
  {
    id: 4,
    name: '李建國',
    role: 'Senior PM, AI Products',
    company: '全球頂尖網路公司',
    companyColor: '#4285F4',
    avatar: '/assets/readdy/nexusstudent04-80x80-squarish-aa47509c.jpg',
    content: '從傳統產業跨界轉型 AI 產品經理，導師幫我重新梳理了整個職涯敘事，對頂尖外商產品文化的理解非常深刻，讓我在 Case Study 中完美展現了產品思維。',
    rating: 5,
    result: '跨界轉型頂尖外商 AI 產品經理',
    salary: '薪資提升 120%',
  },
  {
    id: 5,
    name: '王芳',
    role: 'Senior Data Scientist',
    company: '頂尖 AI 晶片企業',
    companyColor: '#76B900',
    avatar: '/assets/readdy/nexusstudent05-80x80-squarish-b71c213e.jpg',
    content: '進入夢想公司之前，導師帶我深度了解了內部的技術文化和面試偏好，還針對性地優化了我的技術表達。這是我做過最值得的投資，強烈推薦！',
    rating: 5,
    result: '成功入職頂尖 AI 晶片公司',
    salary: 'TC 超過 $320K',
  },
  {
    id: 6,
    name: '趙磊',
    role: 'AI Strategy Consultant',
    company: '全球頂尖顧問機構',
    companyColor: '#003580',
    avatar: '/assets/readdy/nexusstudent06-80x80-squarish-f1188d35.jpg',
    content: '導師幫我將技術背景與商業思維完美融合，打造了獨特的 AI 策略顧問定位。頂尖管理顧問公司面試的 Case Study 陪我演練了 8 遍，最終完美發揮。強烈推薦！',
    rating: 5,
    result: '成功進入全球頂尖顧問公司 AI 策略部門',
    salary: '進入頂尖管理顧問產業',
  },
];
